import { render, staticRenderFns } from "./IncorrectEnd.vue?vue&type=template&id=79db3880&scoped=true&"
import script from "./IncorrectEnd.vue?vue&type=script&lang=js&"
export * from "./IncorrectEnd.vue?vue&type=script&lang=js&"
import style0 from "./IncorrectEnd.vue?vue&type=style&index=0&id=79db3880&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79db3880",
  null
  
)

export default component.exports